// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AskActivity {
  width: 100%;
  height: 54px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  /* background-color: #efeeed; */
  border-radius: 50px;
  /* box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),
    -6px -6px 12px rgba(255, 255, 255, 0.5); */
  background-color: white;
  border: solid 1px #dee0e1;
  cursor: pointer;
  overflow: hidden;
  padding: 5px 10px;
  margin-top: 30px;
}
@media screen and (min-width: 768px) {
  .AskActivity{
    width: 370px;
  }
}
@media screen and (min-width: 1024px) {
  .AskActivity{
    width: 480px;
  }
}
.usable-container{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.AskActivity_active {
  width: 100%;
  height: 625px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: #fefefe;
  border-radius: 20px;
  box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),
    -6px -6px 12px rgba(255, 255, 255, 0.5);
  cursor: pointer;
  overflow: hidden;
  padding: 5px 10px;
  margin-bottom: 15px;
}

.color-combination{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 54px;
  background-color: #fefefe;
  border-radius: 20px;
  cursor: pointer;
  padding: 5px 10px;
}

@media screen and (min-width: 768px) {
  .AskActivity_active {
    width: 375px;
    height: 625px;
    margin-top: 0px !important;
  }
}

@media screen and (min-width: 1024px) {
  .AskActivity_active {
    width: 480px;
    height: 625px; 
  }
}

.askicon {
  margin: 0px 10px 0px 20px;
}
.ask {
  display: inline-block;
  font-size: 1rem;
  /* font-weight: 600; */
}


.DownArrow {
  margin-bottom: 3px;
  margin-left: 10px;
}
::-webkit-scrollbar {
  width: 0;
}

/* Hide horizontal scrollbar */
::-webkit-scrollbar-thumb {
  background: transparent;
}
.MessgeDetils,
.PostCounts--Follow {
  color: #8b8a8a;
}
::-webkit-scrollbar {
  width: 0;
}

/* Hide horizontal scrollbar */
::-webkit-scrollbar-thumb {
  background: transparent;
}
.posts {
  margin-top: 15px !important;
  padding: 0 !important;
  border-radius: 20px !important;
  box-shadow: none !important;
}

@media screen and (min-width: 768px) {
  .posts {
    width: auto !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Modules/Activity/Activites/Asks Activity/AsksActivity.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB;8CAC4C;EAC5C,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB;2CACyC;EACzC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,sBAAsB;AACxB;;;AAGA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,QAAQ;AACV;;AAEA,8BAA8B;AAC9B;EACE,uBAAuB;AACzB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,QAAQ;AACV;;AAEA,8BAA8B;AAC9B;EACE,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".AskActivity {\r\n  width: 100%;\r\n  height: 54px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  /* background-color: #efeeed; */\r\n  border-radius: 50px;\r\n  /* box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),\r\n    -6px -6px 12px rgba(255, 255, 255, 0.5); */\r\n  background-color: white;\r\n  border: solid 1px #dee0e1;\r\n  cursor: pointer;\r\n  overflow: hidden;\r\n  padding: 5px 10px;\r\n  margin-top: 30px;\r\n}\r\n@media screen and (min-width: 768px) {\r\n  .AskActivity{\r\n    width: 370px;\r\n  }\r\n}\r\n@media screen and (min-width: 1024px) {\r\n  .AskActivity{\r\n    width: 480px;\r\n  }\r\n}\r\n.usable-container{\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.AskActivity_active {\r\n  width: 100%;\r\n  height: 625px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  background-color: #fefefe;\r\n  border-radius: 20px;\r\n  box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),\r\n    -6px -6px 12px rgba(255, 255, 255, 0.5);\r\n  cursor: pointer;\r\n  overflow: hidden;\r\n  padding: 5px 10px;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.color-combination{\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 54px;\r\n  background-color: #fefefe;\r\n  border-radius: 20px;\r\n  cursor: pointer;\r\n  padding: 5px 10px;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .AskActivity_active {\r\n    width: 375px;\r\n    height: 625px;\r\n    margin-top: 0px !important;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1024px) {\r\n  .AskActivity_active {\r\n    width: 480px;\r\n    height: 625px; \r\n  }\r\n}\r\n\r\n.askicon {\r\n  margin: 0px 10px 0px 20px;\r\n}\r\n.ask {\r\n  display: inline-block;\r\n  font-size: 1rem;\r\n  /* font-weight: 600; */\r\n}\r\n\r\n\r\n.DownArrow {\r\n  margin-bottom: 3px;\r\n  margin-left: 10px;\r\n}\r\n::-webkit-scrollbar {\r\n  width: 0;\r\n}\r\n\r\n/* Hide horizontal scrollbar */\r\n::-webkit-scrollbar-thumb {\r\n  background: transparent;\r\n}\r\n.MessgeDetils,\r\n.PostCounts--Follow {\r\n  color: #8b8a8a;\r\n}\r\n::-webkit-scrollbar {\r\n  width: 0;\r\n}\r\n\r\n/* Hide horizontal scrollbar */\r\n::-webkit-scrollbar-thumb {\r\n  background: transparent;\r\n}\r\n.posts {\r\n  margin-top: 15px !important;\r\n  padding: 0 !important;\r\n  border-radius: 20px !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .posts {\r\n    width: auto !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
